export function formatNumber(num) {
  return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") : "0";
}
export function formatCurrency(value) {
  if (value >= 1000000000) {
    return `${formatNumber((value / 1000).toFixed(0))}K`;
  }
  return formatNumber(value);
}
export function formatCurrency2(value) {
    value = Math.abs(value);
  if (value >= 1000000000) {
    return `${formatNumber2((value / 1000).toFixed(0))}K`;
  }
  return formatNumber2(value);
}

export function formatNumber2(num) {
  return num
    ? Math.round(num)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    : "0";
}

export function nFormatter(num, digits = 2) {
  var si = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: " triệu" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }
  return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
}
export function formatMoney(
  amount,
  decimalCount = 0,
  decimal = ".",
  thousands = ","
) {
  try {
    if (!amount) return "";
    amount = amount + "";
    if (amount.indexOf(",") > -1) {
      amount = amount.replace(/,/g, "");
    }
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";
    if (amount.indexOf(".") > -1) {
      if (amount.indexOf(".") === amount.length - 1) {
        return amount;
      }
      let amounts = amount.split(".");
      if (amounts.length > 1) {
        decimalCount =
          amounts[1].length < decimalCount ? amounts[1].length : decimalCount;
      } else decimalCount = 0;
    } else decimalCount = 0;
    let i =
      parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))) +
      "";
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {
    return "";
  }
}

var mangso = [
  "không",
  "một",
  "hai",
  "ba",
  "bốn",
  "năm",
  "sáu",
  "bảy",
  "tám",
  "chín",
];
function dochangchuc(so, daydu) {
  var chuoi = "";
  let chuc = Math.floor(so / 10);
  let donvi = so % 10;
  if (chuc > 1) {
    chuoi = " " + mangso[chuc] + " mươi";
    if (donvi == 1) {
      chuoi += " mốt";
    }
  } else if (chuc == 1) {
    chuoi = " mười";
    if (donvi == 1) {
      chuoi += " một";
    }
  } else if (daydu && donvi > 0) {
    chuoi = " lẻ";
  }
  if (donvi == 5 && chuc > 1) {
    chuoi += " lăm";
  } else if (donvi > 1 || (donvi == 1 && chuc == 0)) {
    chuoi += " " + mangso[donvi];
  }
  return chuoi;
}
function docblock(so, daydu) {
  var chuoi = "";
  let tram = Math.floor(so / 100);
  so = so % 100;
  if (daydu || tram > 0) {
    chuoi = " " + mangso[tram] + " trăm";
    chuoi += dochangchuc(so, true);
  } else {
    chuoi = dochangchuc(so, false);
  }
  return chuoi;
}

export function docso(so) {
  if (so == 0) return mangso[0];
  var chuoi = "",
    hauto = "";
  do {
    let ty = so % 1000000000;
    so = Math.floor(so / 1000000000);
    if (so > 0) {
      chuoi = dochangtrieu(ty, true) + hauto + chuoi;
    } else {
      chuoi = dochangtrieu(ty, false) + hauto + chuoi;
    }
    hauto = " tỷ";
  } while (so > 0);
  chuoi = chuoi.substring(1, 2).toUpperCase() + chuoi.substring(2) + " đồng";
  return chuoi;
}
function dochangtrieu(so, daydu) {
  var chuoi = "";
  let trieu = Math.floor(so / 1000000);
  so = so % 1000000;
  if (trieu > 0) {
    chuoi = docblock(trieu, daydu) + " triệu";
    daydu = true;
  }
  let nghin = Math.floor(so / 1000);
  so = so % 1000;
  if (nghin > 0) {
    chuoi += docblock(nghin, daydu) + " nghìn";
    daydu = true;
  }
  if (so > 0) {
    chuoi += docblock(so, daydu);
  }
  return chuoi;
}
